/* Thermal Hero v194: locale-safe product interactions. Kept external so server-side German text replacement cannot alter executable JS. */
(function(){
  'use strict';
  function rootFor(el){ return el && el.closest ? el.closest('.thp-universal') : null; }
  function thumbs(root){ return Array.prototype.slice.call(root.querySelectorAll('.thu-thumb')); }
  function show(root,i){
    var ts=thumbs(root), main=root.querySelector('#thuMainImage');
    if(!ts.length||!main)return;
    i=(i+ts.length)%ts.length;
    root.dataset.galleryIndex=String(i);
    var src=ts[i].getAttribute('data-src'); if(src) main.src=src;
    ts.forEach(function(t,j){t.classList.toggle('is-active',j===i);});
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest && e.target.closest('.thu-thumb,.thu-prev,.thu-next,.thu-variant,[data-minus],[data-plus]');
    if(!t)return;
    var root=rootFor(t); if(!root)return;
    if(t.classList.contains('thu-thumb')){
      e.preventDefault(); var ts=thumbs(root); show(root,ts.indexOf(t)); return;
    }
    if(t.classList.contains('thu-prev')||t.classList.contains('thu-next')){
      e.preventDefault(); var n=parseInt(root.dataset.galleryIndex||'0',10); show(root,n+(t.classList.contains('thu-next')?1:-1)); return;
    }
    if(t.classList.contains('thu-variant')){
      e.preventDefault(); if(t.disabled)return;
      root.querySelectorAll('.thu-variant').forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
      var id=root.querySelector('#thuVariantId'), price=root.querySelector('#thuPrice');
      if(id) id.value=t.getAttribute('data-id')||'';
      if(price && t.getAttribute('data-price')) price.textContent=t.getAttribute('data-price');
      var vid=t.getAttribute('data-id');
      if(vid && window.history && history.replaceState){
        try{var u=new URL(window.location.href);u.searchParams.set('variant',vid);history.replaceState({},'',u.toString());}catch(_e){}
      }
      return;
    }
    var q=root.querySelector('#thuQty'); if(!q)return;
    if(t.hasAttribute('data-minus')){e.preventDefault();q.value=Math.max(1,(parseInt(q.value,10)||1)-1);q.dispatchEvent(new Event('change',{bubbles:true}));}
    if(t.hasAttribute('data-plus')){e.preventDefault();q.value=(parseInt(q.value,10)||1)+1;q.dispatchEvent(new Event('change',{bubbles:true}));}
  },true);
  function init(){document.querySelectorAll('.thp-universal').forEach(function(r){if(!r.dataset.galleryIndex)r.dataset.galleryIndex='0';});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
